// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"ML-z","carouselContainer":"NL-z"};